import { NavigateFunction } from 'react-router-dom'

import { RoutingPaths } from 'app/routes/routes'

import { getOrCreateAviaSearchId } from 'entities/ticket/lib/avia-search-id'
import findTicketFormStore from 'entities/ticket/models/find-ticket/find-ticket-store'
import listTicketsStore from 'entities/ticket/models/list-tickets/list-tickets-store'

import { AirlineContent } from '../model'

export const onSearchFromPromo = (
  data: AirlineContent,
  navigate: NavigateFunction,
) => {
  const { search_filter_body, from_city, to_city, logo_url } = data
  const firstDirection = search_filter_body?.directions?.[0]

  if (!firstDirection?.from || !firstDirection?.to) return

  const dataPrepared = {
    from: {
      cityIataCode: firstDirection?.from,
      cityName: from_city,
      countryName: '',
    },
    to: {
      cityIataCode: firstDirection?.to,
      cityName: to_city,
      countryName: '',
    },
    date: firstDirection?.date,
  }

  const airlines =
    search_filter_body.airline_codes.map((code, i) => ({
      id: i,
      code,
      title: code,
      logo_url,
    })) || []

  findTicketFormStore.setFormFindTicket({
    directions: [dataPrepared],
    filter: { airlines },
  })
  findTicketFormStore.setDataForFilter({ airlines })

  getOrCreateAviaSearchId(findTicketFormStore.formFindTicket)
  listTicketsStore.resetListOfTicket()

  navigate(RoutingPaths.avia.search.path())
}
